module.exports = __webpack_public_path__ + "assets/img/8f9e-cr.svg";